const pasos = [
  {
    num: "1",
    title: "Recepción del Presupuesto",
    color: "from-sky-500 to-sky-400",
  },
  {
    num: "2",
    title: "Evaluación del Presupuesto",
    color: "from-emerald-500 to-emerald-400",
  },
  {
    num: "3",
    title: "Mail de Aprobación, enviado por Dentista Contralor",
    color: "from-lime-500 to-lime-400",
  },
];

const instrucciones = [
  (
    <>
      El <strong>presupuesto</strong> puede ser enviado al mail{" "}
      <a href="mailto:dentistacontralor@gmail.com" className="text-codelco hover:underline">
        dentistacontralor@gmail.com
      </a>{" "}
      o en la Plataforma de Ayuda Dental{" "}
      <a
        href="http://ingresosolicitudes.dentistacontralor.cl"
        target="_blank"
        rel="noreferrer"
        className="text-codelco hover:underline break-all"
      >
        http://ingresosolicitudes.dentistacontralor.cl
      </a>
      , en la cual debe estar activado como usuario con los siguientes datos:{" "}
      <strong>SAP, RUT y mail institucional</strong>.
    </>
  ),
  (
    <>
      Para la <strong>evaluación</strong> de la solicitud, ésta{" "}
      <strong className="underline">SIEMPRE</strong> debe estar acompañada de las
      radiografías con las que el odontólogo/a realizó el presupuesto. Hacemos hincapié
      en este punto, ya que esto es lo que más demora en el trámite de aprobación. Y es{" "}
      <strong className="underline">IMPRESCINDIBLE</strong> para la mayoría de
      procedimientos tales como cirugías, implantes, ortodoncia, rehabilitación,
      obturaciones, etc.
    </>
  ),
  (
    <>
      Por último, si nunca ha recibido un mail de{" "}
      <strong>aprobación desde la Plataforma de Ayuda Dental</strong>, favor contactar
      al contralor al mail{" "}
      <a href="mailto:dentistacontralor@gmail.com" className="text-codelco hover:underline">
        dentistacontralor@gmail.com
      </a>{" "}
      para verificar que esté bien ingresado el correo institucional, pues es allí donde
      recibirá los mails de aprobación.
    </>
  ),
];

export default function Protocolo() {
  return (
    <section className="px-6 md:px-8 py-8 max-w-6xl mx-auto">
      <div className="bg-white border border-gray-300 rounded-md overflow-hidden shadow-sm">
        <div className="bg-gray-50 border-b border-gray-300 px-5 py-3">
          <div className="text-[15px] text-gray-700">Protocolo Solicitud de Ayuda Dental</div>
        </div>

        <div className="px-5 md:px-6 py-6 md:py-7 text-gray-700">
          <p className="text-[15px] font-semibold underline text-gray-800 mb-7">
            Estimadas y estimados supervisores:
          </p>

          <div className="space-y-6 text-[15px] leading-8">
            <p>
              Junto con saludarles, les comentamos que a contar de este mes, y con el
              propósito principal de abreviar el trámite de reembolsos dentales, ya no
              será necesario presentar el formulario de solicitud de beneficio dental que
              nos acompañó por años.
            </p>
            <p>
              Desde ahora basta con el presupuesto realizado por su odontólogo/a, siempre
              y cuando contenga el RUT del paciente. En caso de que Ud. no sea el
              paciente, también deberá contener el suyo, para poder individualizarlo/a.
            </p>
            <p>Dado lo anterior, el nuevo flujo será el siguiente:</p>
          </div>

          <div className="my-9 flex flex-col md:flex-row items-center justify-center gap-4 md:gap-3">
            {pasos.map((paso, index) => (
              <div key={paso.num} className="flex items-center gap-3">
                <div
                  className={`w-[210px] md:w-[225px] min-h-[128px] rounded-2xl bg-gradient-to-br ${paso.color} px-5 py-6 text-center text-white shadow-md flex items-center justify-center`}
                >
                  <div className="text-[19px] leading-tight font-semibold">
                    {paso.num}.- {paso.title}
                  </div>
                </div>
                {index < pasos.length - 1 && (
                  <div className="hidden md:flex text-sky-500 text-6xl leading-none font-light">
                    →
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="space-y-7 text-[15px] leading-8">
            {instrucciones.map((contenido, index) => (
              <p key={index}>
                {index + 1}.- {contenido}
              </p>
            ))}

            <p>
              Finalmente, debe enviar la/s boleta/s a{" "}
              <a href="mailto:dentalrola@codelco.cl" className="text-codelco hover:underline">
                dentalrola@codelco.cl
              </a>
              , en conjunto con el mail de aprobación recibido por parte del contralor,
              en donde cuadren los montos aprobados con la/s boleta/s. En el ASUNTO del
              mail debe indicar: <strong>"Reembolso Dental Rol A SAP xxxxx"</strong>.
              Todo presupuesto aprobado tiene un año de plazo para su reembolso.
            </p>

            <p>
              Recuerda que los presupuestos sobre el millón de pesos deben ser revisados
              una vez terminados para su reembolso.
            </p>

            <p>
              Puede ver también un video explicativo preparado por el dentista contralor
              en Youtube:{" "}
              <a
                href="https://www.youtube.com/watch?v=Shb7dQikyDc"
                target="_blank"
                rel="noreferrer"
                className="text-codelco hover:underline break-all"
              >
                https://www.youtube.com/watch?v=Shb7dQikyDc
              </a>{" "}
              (*)
            </p>

            <p>Atentamente,</p>
          </div>

          <div className="mt-12 pt-4 flex flex-col md:flex-row md:items-center md:justify-between gap-6 text-gray-800 font-semibold text-[15px]">
            <div>Dirección de Admin. de Personal DET</div>
            <div>Dentista Contralor – Dr. Carlos Soto P.</div>
          </div>
        </div>
      </div>
    </section>
  );
}
